module.exports = __webpack_public_path__ + "media/img/pages/profile/csl ger 6-81229d4c4f6742bcac336e343784d945.jpg";